import { render } from "./ContactUs.vue?vue&type=template&id=3248ccb1"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=3248ccb1&lang=css"

import exportComponent from "/home/jk/htdocs/vue/mlcc/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__